import { useState, useEffect } from 'react';

export const usePremiumStatus = () => {
  const [isUserPremium, setIsUserPremium] = useState<boolean>(false); // Initialize with null to indicate loading
  const [isPremiumStateLoading, setIsPremiumStateLoading] = useState(true); // Loading state

  useEffect(() => {
    const crmUser = window?.crm_user;
    if (crmUser && crmUser.access?.includes('web')) {
      setIsUserPremium(true);
    } else {
      setIsUserPremium(false);
    }
    setIsPremiumStateLoading(false); // Set loading to false once the check is complete
  }, []);

  return { isUserPremium, isPremiumStateLoading };
};
